import { defineMessages } from 'react-intl';
export default defineMessages({
  invoicesPaidSuccessfully: {
    id: 'MarkInvoicesPaid.toast.invoice.success',
    defaultMessage: 'The invoices marked as paid successfully!'
  },
  error: {
    id: 'MarkInvoicesPaid.toast.export.error',
    defaultMessage: 'The invoices failed to be marked as paid.'
  }
});
